var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCeftaCentralEuropeanFreeTradeAgreement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_9219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V45H60V0Z",
    fill: "#003399"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9996 21.8578C30.8617 21.8578 31.5605 22.5567 31.5605 23.4188C31.5605 24.2808 30.8617 24.9797 29.9996 24.9797C29.1375 24.9797 28.4387 24.2808 28.4387 23.4188C28.4387 22.5567 29.1375 21.8578 29.9996 21.8578ZM34.1387 23.4188C34.1387 21.1328 32.2856 19.2797 29.9996 19.2797C27.7137 19.2797 25.8605 21.1328 25.8605 23.4188C25.8605 25.7047 27.7137 27.5578 29.9996 27.5578C32.2856 27.5578 34.1387 25.7047 34.1387 23.4188Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0002 16.4297C33.8601 16.4297 36.9893 19.5588 36.9893 23.4188C36.9893 27.2787 33.8601 30.4078 30.0002 30.4078C26.1402 30.4078 23.0111 27.2787 23.0111 23.4188C23.0111 19.5588 26.1402 16.4297 30.0002 16.4297ZM39.5674 23.4188C39.5674 18.1349 35.284 13.8516 30.0002 13.8516C24.7164 13.8516 20.433 18.1349 20.433 23.4188C20.433 28.7026 24.7164 32.9859 30.0002 32.9859C35.284 32.9859 39.5674 28.7026 39.5674 23.4188Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0594 15.4781L14.1188 23.4187L22.0594 31.3594L30 23.4187L22.0594 15.4781Z",
    fill: "#003399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5283 22.1344H37.9783V24.7125H43.5283V22.1344ZM19.2377 22.1344H10.9596V24.7125H19.2377V22.1344ZM25.9689 17.5687L22.3314 13.9312L20.5127 15.7594L24.1408 19.3875L25.9689 17.5687ZM31.2846 4.55624H28.7064V14.5969H31.2846V4.55624Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8973 16.2469C38.1879 16.2469 37.6129 15.6718 37.6129 14.9625C37.6129 14.2532 38.1879 13.6781 38.8973 13.6781C39.6066 13.6781 40.1816 14.2532 40.1816 14.9625C40.1816 15.6718 39.6066 16.2469 38.8973 16.2469Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4715 24.7031C45.7621 24.7031 45.1871 24.1281 45.1871 23.4187C45.1871 22.7094 45.7621 22.1344 46.4715 22.1344C47.1808 22.1344 47.7559 22.7094 47.7559 23.4187C47.7559 24.1281 47.1808 24.7031 46.4715 24.7031Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9998 37.0406C29.2905 37.0406 28.7154 36.4656 28.7154 35.7562C28.7154 35.0469 29.2905 34.4719 29.9998 34.4719C30.7091 34.4719 31.2842 35.0469 31.2842 35.7562C31.2842 36.4656 30.7091 37.0406 29.9998 37.0406Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9998 41.175C29.2905 41.175 28.7154 40.6 28.7154 39.8906C28.7154 39.1813 29.2905 38.6063 29.9998 38.6063C30.7091 38.6063 31.2842 39.1813 31.2842 39.8906C31.2842 40.6 30.7091 41.175 29.9998 41.175Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7215 24.7031C21.0121 24.7031 20.4371 24.1281 20.4371 23.4187C20.4371 22.7094 21.0121 22.1344 21.7215 22.1344C22.4308 22.1344 23.0059 22.7094 23.0059 23.4187C23.0059 24.1281 22.4308 24.7031 21.7215 24.7031Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4717 32.0156L38.6436 30.1969L36.8248 32.0156L38.6436 33.8437L40.4717 32.0156ZM21.2811 33.9844L19.4529 32.1562L17.6248 33.9844L19.4529 35.8031L21.2811 33.9844Z",
    fill: "#FFCC00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_9219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCeftaCentralEuropeanFreeTradeAgreement);
export default __webpack_public_path__ + "static/media/cefta Central European Free Trade Agreement.27a21805645856b586523643713010ec.svg";
export { ForwardRef as ReactComponent };